import React from "react";

export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="skip-to-content"
      onFocus={(e) => {
        e.currentTarget.style.left = "1rem";
      }}
      onBlur={(e) => {
        e.currentTarget.style.left = "-9999px";
      }}
    >
      Skip to main content
    </a>
  );
}